import { useEffect, useState } from 'react';

import { useDebounce } from './useDebounce';

export const useScreenResize = (delay: number = 300) => {
  const [resizeValue, setResizeValue] = useState<number>(0);
  const debounceVal = useDebounce<number>(resizeValue, delay);

  useEffect(() => {
    const handleResize = () => setResizeValue((prev) => prev + 1);

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return debounceVal;
};
